export const geodesyAndLandManagementConst = {
  path: "/single-programs/geodesy-and-land-management",
  title: "ИНЖЕНЕРНО-ГЕОГРАФИЧЕСКИЙ ФАКУЛЬТЕТ – ГЕОДЕЗИЯ И ЗЕМЛЕУСТРОЙСТВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Геодезия и землеустройство — точность, пространство и право</h2>
      <p>
        Эта программа готовит специалистов, которые работают с земельными ресурсами, пространственными данными и правовой документацией.
        Студенты изучают геодезические измерения, создание карт и планов, управление кадастрами, зонированием и использованием земель.
      </p>
      <p>Современное образование в этой области сочетает технические, правовые и цифровые навыки.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Геодезия и спутниковые технологии (GNSS)</li>
        <li>Цифровая картография и ГИС-системы</li>
        <li>Землеустройство и кадастр</li>
        <li>Топография и фотограмметрия</li>
        <li>Правовое регулирование в землеустройстве</li>
        <li>Оценка недвижимости и зонирование</li>
        <li>Дистанционное зондирование Земли</li>
        <li>Международные стандарты и нормы ЕС</li>
      </ul>
      <p>В рамках программы предусмотрены полевые практики, работа с профессиональным оборудованием и цифровыми платформами.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-геодезист</li>
        <li>Землеустроитель</li>
        <li>Кадастровый инженер</li>
        <li>Специалист по управлению земельными ресурсами</li>
        <li>Оценщик недвижимости и консультант по земле</li>
        <li>Эксперт по геоинформационным системам</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €80,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с возможностью работать в ЕС</li>
        <li>Учёба на русском или английском языке</li>
        <li>Полевые выезды и работа с современными приборами</li>
        <li>Гибкая форма обучения: дистанционно или очно</li>
        <li>Практика в кадастровых и землеустроительных службах</li>
        <li>Поддержка приёмной комиссии на всех этапах</li>
      </ul>
      <p>
        <strong>Специалисты, без которых невозможно строительство и планирование</strong>
      </p>
      <p>
        Наши выпускники участвуют в градостроительных проектах, ведут кадастровую документацию, работают в международных геоинформационных
        компаниях.
      </p>
      <br />
      <p className="padding-left">
        «Геодезия — это точка опоры для всего, что мы строим. Мы обучаем ориентироваться в пространстве — точно и профессионально.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать подходящий формат, собрать документы и пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Геодезия и землеустройство — точность, пространство и право
    Эта программа готовит специалистов, которые работают с земельными ресурсами, пространственными данными и правовой документацией. Студенты изучают геодезические измерения, создание карт и планов, управление кадастрами, зонированием и использованием земель.
    Современное образование в этой области сочетает технические, правовые и цифровые навыки.
    Что вы будете изучать?
    • Геодезия и спутниковые технологии (GNSS)
    • Цифровая картография и ГИС-системы
    • Землеустройство и кадастр
    • Топография и фотограмметрия
    • Правовое регулирование в землеустройстве
    • Оценка недвижимости и зонирование
    • Дистанционное зондирование Земли
    • Международные стандарты и нормы ЕС
    В рамках программы предусмотрены полевые практики, работа с профессиональным оборудованием и цифровыми платформами.
    Кем можно работать после окончания?
    • Инженер-геодезист
    • Землеустроитель
    • Кадастровый инженер
    • Специалист по управлению земельными ресурсами
    • Оценщик недвижимости и консультант по земле
    • Эксперт по геоинформационным системам
    Зарплата в Европе: от €45,000 до €80,000 в год
    Почему выбирают нас?
    • Европейский диплом с возможностью работать в ЕС
    • Учёба на русском или английском языке
    • Полевые выезды и работа с современными приборами
    • Гибкая форма обучения: дистанционно или очно
    • Практика в кадастровых и землеустроительных службах
    • Поддержка приёмной комиссии на всех этапах
    Специалисты, без которых невозможно строительство и планирование
    Наши выпускники участвуют в градостроительных проектах, ведут кадастровую документацию, работают в международных геоинформационных компаниях.
    «Геодезия — это точка опоры для всего, что мы строим. Мы обучаем ориентироваться в пространстве — точно и профессионально.»

    Как поступить?
    Приёмная комиссия поможет вам выбрать подходящий формат, собрать документы и пройти весь процесс поступления.
  `,
};
